import React from 'react';
import EditIcon from '../../../assets/icons/edit.svg';
import CrossIcon from '../../../assets/icons/cross.svg';
import SaveIcon from '../../../assets/icons/save.svg';
import EyeIcon from "../../../assets/icons/eye-show.svg";
import DeleteIcon from "../../../assets/icons/trash.svg";
import SearchIcon from '../../../assets/icons/search.svg';
import ImageAuto from "../../../assets/images/image.png";
import ImagePTS from "../../../assets/images/photo-pts.png";
import WorkIcon from "../../../assets/icons/work.svg";
import EditRequest from "../../../assets/icons/edit-request.svg";
import PrintIcon from "../../../assets/icons/print.svg";
import NoImage from "../../../assets/images/no-image.png";
import NoResults from "../../../assets/icons/no-results.svg";
import Download from "../../../assets/icons/download.svg";
import { iconNames } from '../constants/icon-names';

export const icons = {
  [iconNames.EDIT]: EditIcon,
  [iconNames.CROSS]: CrossIcon,
  [iconNames.SAVE]: SaveIcon,
  [iconNames.EYE]: EyeIcon,
  [iconNames.DELETE]: DeleteIcon,
  [iconNames.SEARCH]: SearchIcon,
  [iconNames.WORK]: WorkIcon,
  [iconNames.EDIT_REQUEST]: EditRequest,
  [iconNames.IMAGE_AUTO]: ImageAuto,
  [iconNames.IMAGE_PTC]: ImagePTS,
  [iconNames.PRINT]: PrintIcon,
  [iconNames.NOIMAGE]: NoImage,
  [iconNames.NORESULTS]: NoResults,
  [iconNames.DOWNLOAD]: Download,
};
